export const cacheKeys = {
  getConnections: 'getConnections',
  getConnection: 'getConnection',
  createConnection: 'createConnection',
  editConnection: 'editConnection',
  deleteConnection: 'deleteConnection',
};
